/*** IMPORTS FROM imports-loader ***/
(function() {

/*eslint-disable */
var $ = require("jquery");

require("site/mobile/jquery-mobile-configure");
require("jquery-mobile-router");

module.exports = function(callback) {
  require("jquery-mobile");
  callback();
};

}.call(window));